// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__p2Njn","topBottomGutter":"Layout_topBottomGutter__1MdlF"};